import React from 'react'

export const backgroundColorTourConfig = (t) => ({
    id: 'background-color-settings',
    name: t('tour:background_color_settings_name'),
    description: t('tour:background_color_settings_desc'),
    icon: 'bg-colors',
    hidden: true,
    disableAutoResume: true,
    steps: [
        {
            target: '.ant-modal-content',
            title: t('tour:background_color_settings_step_0_title'),
            content: (
                <div>
                    <p>{t('tour:background_color_settings_step_0_content')}</p>
                </div>
            ),
            placement: 'center',
            waitFor: '.ant-modal-content'
        },
        {
            target: '[data-tour="sketch-picker"]',
            title: t('tour:background_color_settings_step_1_title'),
            content: (
                <div>
                    <p>{t('tour:background_color_settings_step_1_content')}</p>
                </div>
            ),
            placement: 'right',
            waitFor: '.sketch-picker'
        },
        // {
        //     target: '[data-tour="bg-color-remove"]',
        //     title: 'Remove Color',
        //     content: (
        //         <div>
        //             <p>Click here to remove the background color.</p>
        //         </div>
        //     ),
        //     placement: 'top',
        // },
        {
            target: '[data-tour="bg-color-confirm"]',
            title: t('tour:background_color_settings_step_2_title'),
            content: (
                <div>
                    <p>{t('tour:background_color_settings_step_2_content')}</p>
                </div>
            ),
            placement: 'top',
        }
    ]
})
